import React, { Component } from 'react'
import PlaceHolder from 'components/PlaceHolder';

import './CardVehicle.scss'

export default class CardVehicleListPlaceholder extends Component {
    render() {
        return (
            <div id={this.props.id ? this.props.id : undefined} className='CardVehicle CardVehicle--grid'>
                <div className={'CardVehicle--grid__container'}>
                    <div className={'CardVehicle--grid__container__photos'}>
                        <figure>
                            <PlaceHolder />
                        </figure>
                    </div>
                    <a rel="noreferrer nofollow" className='CardVehicle__link'>
                        <div className='CardVehicle__details'>
                            <div className='CardVehicle__details__header'>
                                <h2 className="CardVehicle__details__header__title"><PlaceHolder /></h2>
                                <h3 className="CardVehicle__details__header__description"><PlaceHolder /></h3>
                            </div>
                            <div className='CardVehicle__details__content'>
                                <ul className='CardVehicle__details__content__feature'>
                                    <li className='CardVehicle__details__content__feature__info'><PlaceHolder width="px" px="100" /></li>
                                    <li className='CardVehicle__details__content__feature__info'><PlaceHolder width="px" px="100" /></li>
                                </ul>
                            </div>
                            <div className='CardVehicle__details__footer'>
                                <span className="CardVehicle__details__footer__state"><PlaceHolder width="px" px="170" /></span>
                                <span className="CardVehicle__details__footer__a-type"><PlaceHolder width="px" px="170" /></span>
                            </div>
                        </div>
                    </a>
                    <div className='CardVehicle__send-lead'>
                        <div className='CardVehicle__send-lead__header'>
                            <strong className={'CardVehicle__details__content__price'}><PlaceHolder /></strong>
                        </div>
                        <div className='CardVehicle__send-lead__footer'>
                            <div className="CardVehicle__send-lead__footer__buttons">
                                <PlaceHolder />
                                <PlaceHolder />
                                <div className="CardVehicle__send-lead__footer__buttons__cookie">
                                    <PlaceHolder />
                                    <PlaceHolder />
                                    <PlaceHolder />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


